export default __webpack_public_path__ + "media/zurb/img/party/zurb-7e3ac54d49b03de16e4370f63572576e.png";